const state = {
    createToggleStatus: false,
    addTrack: {
        status: false,
        id: null,
    },
    addToModalStatus: false,
    playlists: [],
    productId: -1,
};

const getters = {
    playlists: (state) => state.playlists,
};

const actions = {
    removePlaylist(context, playlistId) {
        axios
            .post("/members/playlist/remove-playlist", { playlistId })
            .then((response) => {
                context.commit("removePlaylist", playlistId);
            })
            .catch((error) => {
                console.log(error);
            });
    },
    addItem(context, playlistId) {
        axios
            .post(`/members/playlist/get`, { playlistId: playlistId })
            .then((response) => {
                context.commit("addItem", {
                    updatedPlaylist: response.data,
                    playlistId: playlistId,
                });
            })
            .catch((error) => {
                console.log(error);
            });
    },
};

const mutations = {
    setPlaylists(state, playlists) {
        state.playlists = playlists;
    },
    removePlaylist(state, id) {
        state.playlists = state.playlists.filter((playlist) => {
            return playlist.id !== id;
        });
    },
    addPlaylist(state, playlist) {
        state.playlists.push(playlist);
    },
    addProduct(state, id) {
        state.productId = id;
    },
    addItem(state, payload) {
        let currentPlaylist = state.playlists.find(
            (x) => x.id === payload.playlistId
        );

        let firstItem = payload.updatedPlaylist[0];

        currentPlaylist.backing_tracks.unshift(firstItem);
    },
    removeItem(state, payload) {
        let currentPlaylist = state.playlists.find(
            (x) => x.id === payload.playlistId
        ).backing_tracks;
        let backingTrackIndex = currentPlaylist
            .map(function (x) {
                return x.id;
            })
            .indexOf(payload.itemId);
        currentPlaylist.splice(backingTrackIndex, 1);
    },
    removeWatchlistItem(state, payload) {
        let currentWatchlist;

        if (payload.type === "course") {
            currentWatchlist = state.playlists.courses;
        } else if (payload.type === "learning-path") {
            currentWatchlist = state.playlists.learningPaths;
        } else if (payload.type === "lesson") {
            currentWatchlist = state.playlists.lessons;
        }

        let itemIndex = currentWatchlist
            .map(function (x) {
                return x.id;
            })
            .indexOf(payload.itemId);

        currentWatchlist.splice(itemIndex, 1);
    },
    toggleCreatePlaylist(state, value) {
        state.createToggleStatus = value;
    },
    toggleAddTrack(state, payload) {
        state.addTrack = {
            status: payload.status,
            id: payload.id,
        };
    },
    toggleAddToModal(state, value) {
        state.addToModalStatus = value;
    },
};

export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations,
};
